<template>
  <div>
    <nav class="navbar md-down-fixed-top navbar-expand-md navbar-light bg-body pt-4 d-flex flex-column align-items-center">
      <div class="container" style="height: 100%">
        <a class="navbar-brand d-flex flex-row align-items-center" href="/">
          <img
            :src="$store.state.brand.logo"
            class="d-inline-block align-top"
            :alt="$store.state.brand.name"
          />
          <span class="mobileHide">{{$store.state.campaign.name}}</span>
        </a>
        <div class="d-none d-md-flex">
          <ul class="navbar-nav ml-auto d-flex align-items-center">
            <li class="nav-item">
              <a class="nav-link">
                <div
                  v-html="iconLogout"
                  @click="$store.dispatch('logout'); $router.push('/')"
                  class="ml-4 f-icon"
                  style="line-height:1px;width:30px;cursor: pointer"
                ></div>
              </a>
            </li>
          </ul>
        </div>
        <div class="d-flex d-md-none">
          <ul class="navbar-nav ml-auto d-flex">
            <a class="nav-item nav-link">
              <i class="fal fa-cog" style="font-size: 1.5rem;"></i>
            </a>
          </ul>
        </div>
      </div>
    </nav>
    <nav class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap" id="bottomBar">
      <a class="nav-item nav-link">
        <i class="fal fa-home"></i>
        {{$t('tenants.home')}}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-chart-bar"></i>
        {{$t('tenants.leaderboard')}}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-tags"></i>
        {{$t('tenants.catalog')}}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-qrcode"></i>
        {{$t('tenants.insertcode')}}
      </a>

      <a class="nav-item nav-link">
        <div style="line-height:1px;"></div>
        {{$t('Invite')}} MGM
      </a>
    </nav>
    <template v-if="!credentialType && !pendingConfirmation">
      <main class="actions c-complete-profile">
          <div class="container">
            <form
            data-vv-scope="incompleteProfile"
            @submit.prevent="validateForm('incompleteProfile', updateProfile)"
            style="margin-top: 4rem;"
            >
            <div class="row" v-if="showProfiling">
                <div class="col-md-4 offset-md-2">
                <div class="form-group">
                    <input
                    id="first_name"
                    type="text"
                    class="form-control"
                    v-model="first_name"
                    :class="{'is-invalid': errors.has('incompleteProfile.first_name')}"
                    v-validate="'required'"
                    data-vv-as="Name"
                    name="first_name"
                    :placeholder="$t('First name')"
                    />
                    <label for="first_name" class="h5">{{ $t('First name') }}</label>
                    <span
                    v-show="errors.has('incompleteProfile.first_name')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                    >
                    <strong>{{ errors.first('incompleteProfile.first_name') }}</strong>
                    </span>
                </div>
                </div>
                <div class="col-md-4">
                <div class="form-group">
                    <input
                    id="last_name"
                    type="text"
                    class="form-control"
                    v-model="last_name"
                    :class="{'is-invalid': errors.has('incompleteProfile.last_name')}"
                    name="last_name"
                    data-vv-as="Surname"
                    v-validate="'required'"
                    :placeholder="$t('Last name')"
                    />
                    <label for="last_name" class="h5">{{ $t('Last name') }}</label>
                    <span
                    v-show="errors.has('incompleteProfile.last_name')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                    >
                    <strong>{{ errors.first('incompleteProfile.last_name') }}</strong>
                    </span>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="form-group" v-if="showCredential">
                    <input
                        id="register_credential"
                        type="text"
                        class="form-control"
                        name="register_credential"
                        v-model="credential"
                        value
                        data-vv-as="Email/Mobile"
                        v-validate="'required|phoneOrEmail'"
                        :placeholder="$t('Email / Mobile number')"
                        v-if="$store.state.brand.idm_phone_login_enabled"
                    />
                    <input
                        id="register_credential"
                        type="text"
                        class="form-control"
                        name="register_credential"
                        v-model="credential"
                        value
                        data-vv-as="Email"
                        v-validate="'required|email'"
                        :placeholder="$t('Email')"
                        v-else
                    />
                    <label
                        for="register_credential"
                        v-if="$store.state.brand.idm_phone_login_enabled"
                        class="h5"
                    >{{ $t('Email / Mobile number') }}</label>
                    <label for="register_credential" v-else class="h5">{{ $t('Email') }}</label>
                    <span
                        v-show="errors.has('incompleteProfile.register_credential')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                    >
                        <strong>{{ errors.first('incompleteProfile.register_credential') }}</strong>
                    </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="form-check" v-if="showAgreements">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="agreements.tos"
                        name="tos"
                        id="tos"
                        ref="tos"
                        v-validate="'required'"
                    />
                    <label class="form-check-label" for="tos">
                        dichiaro di aver letto, compreso ed accettato i contenuti dell’<a
                            href="/info/privacy"
                            class="btn-not-spinner"
                            target="_blank"
                          >Informazione Privacy</a> e delle <a
                            href="/info/tos"
                            class="btn-not-spinner"
                            target="_blank"
                          >Condizioni di servizio</a> della piattaforma web.
                    </label>
                    <span
                        v-show="errors.has('incompleteProfile.tos')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                    >
                        <strong>{{ errors.first('incompleteProfile.tos') }}</strong>
                    </span>
                    </div>
                    <!-- <div class="form-check"> -->
                    <!-- <input
                        class="form-check-input"
                        type="checkbox"
                        name="privacy"
                        id="privacy"
                        ref="privacy"
                        v-model="agreements.privacy"
                        v-validate="'required'"
                    />
                    <label class="form-check-label" for="privacy">{{$t('Agree with privacy terms')}}</label>
                    <span
                        v-show="errors.has('incompleteProfile.privacy')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                    >
                        <strong>{{ errors.first('incompleteProfile.privacy') }}</strong>
                    </span>
                    </div> -->
                    <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        name="marketing"
                        id="marketing"
                        ref="marketing"
                        v-model="agreements.marketing"
                    />
                    <label class="form-check-label" for="marketing">{{$t('Agree with marketing terms')}}</label>
                    </div>
                    <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        name="profilation"
                        ref="profilation"
                        id="profilation"
                        v-model="agreements.profilation"
                    />
                    <label
                        class="form-check-label"
                        for="profilation"
                    >{{$t('Agree with profilation terms')}}</label>
                    </div>
                    <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        name="third"
                        id="third"
                        ref="third"
                        v-model="agreements.third"
                    />
                    <label
                        class="form-check-label"
                        for="third"
                    >{{$t('Agree with third party marketing terms')}}</label>
                    </div>
                    <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        name="third_profilation"
                        id="third_profilation"
                        ref="third_profilation"
                        v-model="agreements.third_profilation"
                    />
                    <label
                        class="form-check-label"
                        for="third_profilation"
                    >{{$t('Agree with third party profilation terms')}}</label>
                    </div>

                    <div class="form-group col-12 text-center mt-5">
                    <button type="submit" class="btn btn-primary btn-lg">{{ $t('Submit') }}</button>
                    </div>
                </div>
            </div>
            </form>

          </div>
      </main>
    </template>
    <template v-else>
      <div class="container">
        <div class="CTA" style="min-height:0">
          <h2 class="h1 display-4">{{ $t('Verify new account') }}</h2>
          <h5 class="mb-0" v-if="credentialType == 'mobile' ">
            {{ $t('We have sent you an SMS with the code to verify the number') }}
            <br />
            <strong x-ms-format-detection="none">{{confirmationAddress}}</strong>
          </h5>
          <h5 class="mb-0" v-else>
            {{ $t('We have sent you an email with the address verification code') }}
            <br />
            <strong x-ms-format-detection="none">{{confirmationAddress}}</strong>
          </h5>
        </div>
        <form
          class="mt-5 row"
          style="padding-left:15px;padding-right:15px;"
          data-vv-scope="confirmationForm"
          @submit.prevent="validateForm('confirmationForm', verify)"
          v-cloak
        >
          <div class="form-group col-12">
            <input
              id="confirmation"
              type="text"
              class="form-control $errors->has('confirmation') ? ' is-invalid' : '' }}"
              name="confirmation"
              required
              :placeholder="$t('Confirmation Code')"
              v-validate="'required'"
              v-model="confirmationCode"
              maxlength="5"
            />
            <label for="confirmation" class="h5">{{ $t('Confirmation Code') }}</label>
          </div>
          <div
            class="row"
            style="width:100%"
            :style="{'margin-top':($mq!=='sm'  && $mq!=='md')?'89px':'0'}"
          >
            <div class="col-12 col-lg-6 text-center text-lg-left" style="line-height:48px">
              <small>{{$t('Didn\'t receive the code?')}}</small>
              <a class="c-form-actions__link btn-not-spinner" href="#" @click="resendVerifyCode">{{ $t('Resend') }}</a>
            </div>
            <div
              class="form-group col-12 col-lg-6 text-center text-lg-right"
              style="padding-top: 0"
            >
              <button class="btn btn-primary btn-lg">{{ $t('Confirm') }}</button>
            </div>
          </div>
        </form>
      </div>
    </template>
  </div>
</template>
<script>
import _ from "lodash";
import iconLogout from "./../assets/svg/fnz_logout.svg";
export default {
  name: "complete-profile",
  data() {
    return {
      confirmationCode: null,
      first_name: null,
      last_name: null,
      credential: null,
      credentialType: null,
      confirmationAddress: null,
      agreements: {
        tos: false,
        privacy: true,
        marketing: false,
        profilation: false,
        third: false,
        third_profilation: false
      },
      iconLogout: iconLogout
    };
  },
  created() {
      if(this.pendingConfirmation) {
          this.confirmationAddress = this.pendingConfirmation.address;
          this.credentialType = this.pendingConfirmation.type;
      }
  },
  computed: {
    pendingConfirmation() {
        return this.$store.getters.getPendingConfirmation;
    },
    missingFields() {
      return this.$store.getters.getMissingProfileFields;
    },
    showCredential() {
      return _.find(this.missingFields, [
        "id",
        "email"
      ]);
    },
    showProfiling() {
      return _.find(this.missingFields, [
        "id",
        "first_name"
      ]);
    },
    showAgreements() {
      return true;
    }
  },
  methods: {
    async updateProfile() {
      this.$store.commit("showSpinner");
      try {
        if (this.first_name && this.last_name) {
          const responseProfile = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/profile/info",
            {
              first_name: this.first_name,
              last_name: this.last_name
            }
          );
        }

        if (this.agreements.tos && this.agreements.privacy) {
          const responseAgreements = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/agreements",
            {
              agreements: this.agreements
            }
          );
        }

        if (this.credential) {
          const responseCredential = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/profile/credentials",
            {
              credential: this.credential
            }
          );
          this.credentialType = responseCredential.data.data.credential_type;
          this.confirmationAddress =
            responseCredential.data.data.credential_address;
        } else if(!this.showCredential) {
          this.$router.replace("/dashboard");
        }
      } catch (err) {
        this.$store.commit("hideSpinner");
          let errorStatus = _.get(error, "response.status");
          if (errorStatus === 409) {
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("User Exist")
            });
          } else {
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("Error")
            });
          }
      }
      this.$store.commit("hideSpinner");
    },
    async verify() {
      this.$store.commit("showSpinner");

      try {
          const responseVerify = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/profile/credentials/verify",
            {
              credential: this.confirmationAddress,
              credential_type: this.credentialType,
              verify_code: this.confirmationCode
            }
          );
        await this.$store.dispatch('getUserInfo');
        this.$router.replace("/dashboard");
      } catch (err) {
        let errorStatus = _.get(err, "response.status");
        if (errorStatus === 404) {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "Invalid code"
          });
        } else {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "An error occurred"
          });
        }
      }

      this.$store.commit("hideSpinner");
    },
    async resendVerifyCode() {
      this.$store.commit("showSpinner");
      if (this.credentialType === "email") {
        const responseVerify = await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/email/resendVerify",
          {
            email: this.confirmationAddress
          }
        );
      } else {
        const responseVerify = await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/mobile/resendVerify",
          {
            mobile: this.confirmationAddress
          }
        );
      }

      this.$store.commit("hideSpinner");
    }
  },
  components: {
    iconLogout: iconLogout
  }
};
</script>
<style scoped>
@media (max-width: 991.98px) {
    .c-complete-profile {
        margin-top: 250px;
    }
}
</style>